import axios from "axios";
import environment from "../constants/environment";
import * as resultTypes from "../constants/resultTypes";

class EirSearchApi {
  static search(imei) {
    const instance = axios.create({
      baseURL: environment.url,
      headers: {
        Accept: "application/json",
      },
    });

    return new Promise((resolve, reject) => {
      instance
        .get("/rest-api/public/imei/" + imei)
        .then((response) => {
          const data = response.data;
          const status = data.status;
          if (status != null && status != undefined) resolve(status);
          else resolve(resultTypes.NOT_FIND);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            resolve(resultTypes.NOT_FIND);
          } else reject(error);
        });
    });
  }
}

export default EirSearchApi;
